import { render, staticRenderFns } from "./ResponseCard.vue?vue&type=template&id=daf1ddf8"
import script from "./ResponseCard.vue?vue&type=script&lang=js"
export * from "./ResponseCard.vue?vue&type=script&lang=js"
import style0 from "./ResponseCard.vue?vue&type=style&index=0&id=daf1ddf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports